/**
 *
 * @constructor
 */
function SettingsPage() {
    /**
     *
     */
    SettingsPage.prototype.initialize = function (console) {
        this.id = "settings";
        this.console = console;
        this.updateFirmwareDialog = {};

        return this;
    };

    /**
     *
     */
    SettingsPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.useDefaultCloudServer = this.console.consoleService.portalServerUrl.indexOf("https://www.thing-it.com") == 0;
        this.cloudPortalServerUrl = this.console.consoleService.portalServerUrl;
        this.cloudProxyServerUrl = this.console.consoleService.proxyServerUrl;
        this.serverMode = this.console.consoleService.settings.serverMode;
        this.useLocalNodeBoxIfAvailable = this.console.consoleService.settings.useLocalNodeBoxIfAvailable;
        this.host = this.console.consoleService.settings.host;
        this.port = this.console.consoleService.settings.port;

        // Get latest local settings from Gateway

        //this.console.consoleService.tryLocalConnection().done(function () {
        //    this.console.consoleService.logDebug("Tried local connection.", this.console.node);
        //
        if (this.console.node) {
            this.console.consoleService.getNodeState(this.console.node).done(function (state) {
                this.lastConfigurationTimestamp = state.lastConfigurationTimestamp;
                this.firmwareVersion = state.firmwareVersion;

                deferred.resolve();
            }.bind(this)).fail(function (error) {
                this.console.consoleService.logDebug(error);
                deferred.reject();
            }.bind(this));
        } else {
            deferred.resolve();
        }
        //}.bind(this)).fail(function (error) {
        //    this.console.consoleService.logDebug(error);
        //    deferred.reject(error);
        //}.bind(this));

        return deferred.promise();
    };

    /**
     *
     */
    SettingsPage.prototype.leave = function () {
    };

    /**
     *
     */
    SettingsPage.prototype.openScanForLocalNodeBoxDialog = function () {
        this.nodeBoxIpAddress = null;

        this.console.Ui.turnOn("scanForLocalNodeBoxDialog");

        networkinterface.getIPAddress(function (ip) {
            if (ip) {
                this.mobileIpAddress = ip;

                this.console.safeApply();

                var segments = ip.split(".");

                this.gateways = [];

                for (var n = Math.max(0, segments[3] - 20); n < Math.min(255, segments[3] + 20); ++n) {
                    this.currentlyScannedIpAddress = segments[0] + "." + segments[1] + "." + segments[2] + "." + n;
                    this.console.safeApply();

                    this.console.consoleService.ping(this.currentlyScannedIpAddress).done(function (gateway) {
                        this.gateways.push(gateway);
                        this.console.safeApply();
                    }.bind(this));
                }
            }

        }.bind(this));
    };

    /**
     *
     */
    SettingsPage.prototype.applyScanResults = function () {
        this.host = this.selectedGateway.ipAddress;
        this.port = 3001;

        this.closeScanForLocalNodeBoxDialog();
    };

    /**
     *
     */
    SettingsPage.prototype.closeScanForLocalNodeBoxDialog = function () {
        this.console.Ui.turnOff("scanForLocalNodeBoxDialog");
    };

    /**
     *
     */
    SettingsPage.prototype.openSettingsDialog = function () {
        this.console.Ui.turnOn("serverSettingsDialog");
    };

    /**
     *
     */
    SettingsPage.prototype.onServerModeChange = function () {
        if (this.serverMode === "local") {
            this.host = this.host ? this.host : "localhost";
            this.port = this.port ? this.port : 3001;
        }
        else if (this.serverMode === "test") {
            this.host = "localhost";
            this.port = 3000;
        }
    };

    /**
     *
     */
    SettingsPage.prototype.applySettingsAndClose = function () {
        if (!this.host || !this.port) {
            return; // TODO Validation!
        }

        this.applySettings();
        this.console.Ui.turnOff("serverSettingsDialog");
    };

    /**
     *
     */
    SettingsPage.prototype.applySettings = function () {
        this.console.consoleService.settings.serverMode = this.serverMode;
        this.console.consoleService.settings.useLocalNodeBoxIfAvailable = this.useLocalNodeBoxIfAvailable;
        this.console.consoleService.settings.host = this.host;
        this.console.consoleService.settings.port = this.port;

        this.console.consoleService.applySettings();
        this.console.reinitializeServerCommunication();
    };

    /**
     *
     */
    SettingsPage.prototype.updateFirmware = function () {
        this.console.openConfirmationDialog("Confirm to update the [thing-it-node] Firmware to its latest version. Your Node Box will be restarted after.",
            function () {
                this.console.consoleService.updateFirmware(this.console.node).done(function () {
                    console.log("Firmware update initiated.");
                    this.console.Ui.turnOn("updateFirmwareDialog");

                    this.pollFirmwareUpdate(120000);
                }.bind(this)).fail(function () {
                    this.console.openMessageDialog("Failed to update Firmware.", "error");
                }.bind(this));
            }.bind(this));
    };

    /**
     *
     */
    SettingsPage.prototype.pollFirmwareUpdate = function (initialTimeout) {
        if (!initialTimeout) {
            initialTimeout = 0;
        } else {
            this.updateFirmwareDialog.remainingSecondsTillRetry = Math.round(initialTimeout / 1000);
            this.updateFirmwareDialog.state = "waiting";

            this.console.safeApply();

            this.updateFirmwareDialog.countdownInterval = window.setInterval(function () {
                this.updateFirmwareDialog.remainingSecondsTillRetry = Math.max(0, this.updateFirmwareDialog.remainingSecondsTillRetry - 1);

                this.console.safeApply();
            }.bind(this), 1000);
        }

        this.updateFirmwareDialog.initialTimeout = window.setTimeout(function () {
            if (this.updateFirmwareDialog.countdownInterval) {
                window.clearInterval(this.updateFirmwareDialog.countdownInterval);
            }

            this.console.consoleService
                .getNodeState(this.console.node).done(function () {
                this.updateFirmwareDialog.state = "connected";

                this.console.safeApply();
            }.bind(this)).fail(function () {
                this.updateFirmwareDialog.state = "disconnected";

                this.console.safeApply();

                this.updateFirmwareDialog.waitTimeout = window.setTimeout(function () {
                    this.updateFirmwareDialog.remainingSecondsTillRetry = 10;

                    this.updateFirmwareDialog.state = "waiting";
                    this.console.safeApply();

                    this.updateFirmwareDialog.countdownInterval = window.setInterval(function () {
                        this.updateFirmwareDialog.remainingSecondsTillRetry = Math.max(0, this.updateFirmwareDialog.remainingSecondsTillRetry - 1);

                        this.console.safeApply();
                    }.bind(this), 1000);

                    this.updateFirmwareDialog.retryTimeout = window.setTimeout(function () {
                        window.clearInterval(this.updateFirmwareDialog.countdownInterval);

                        this.pollFirmwareUpdate();
                    }.bind(this), 10000);
                }.bind(this), 3000);
            }.bind(this));
        }.bind(this), initialTimeout);
    };

    /**
     *
     */
    SettingsPage.prototype.closeUpdateFirmwareDialog = function () {
        if (this.updateFirmwareDialog.initialTimeout) {
            window.clearTimeout(this.updateFirmwareDialog.initialTimeout);
        }

        if (this.updateFirmwareDialog.waitTimeout) {
            window.clearTimeout(this.updateFirmwareDialog.waitTimeout);
        }

        if (this.updateFirmwareDialog.retryTimeout) {
            window.clearTimeout(this.updateFirmwareDialog.retryTimeout);
        }

        if (this.updateFirmwareDialog.countdownInterval) {
            window.clearInterval(this.updateFirmwareDialog.countdownInterval);
        }

        this.console.Ui.turnOff("updateFirmwareDialog");
    };

    /**
     *
     */
    SettingsPage.prototype.openPairGatewayDialog = function () {
        var deferred = $.Deferred();

        if (this.serverMode == 'local' || !this.console.loggedInUser) {
            this.console.openLoginDialog("Enter your credentials for thing-it.com:", function () {
                deferred.resolve();
            }.bind(this));
        } else {
            deferred.resolve();
        }

        deferred.promise().done(function () {
            this.pairMeshMode = 'new';
            this.console.Ui.turnOn("newMeshMode");
            this.console.Ui.turnOn("pairGatewayDialog");

            this.console.consoleService
                .getMeshes()
                .done(
                    function (meshes) {
                        this.meshes = meshes;

                        this.console.safeApply();
                    }.bind(this)).fail(function (error) {
            });
        }.bind(this)).fail(function (error) {
            this.console.consoleService.logError(error);
        }.bind(this));
    };

    /**
     *
     */
    SettingsPage.prototype.closePairGatewayDialog = function () {
        this.console.Ui.turnOff("pairGatewayDialog");
    };

    /**
     *
     */
    SettingsPage.prototype.openRepairGatewayDialog = function () {
        this.console.openConfirmationDialog("Re-pairing the Gateway would ovewrite all pairing settings. Continue?", function () {
            this.openPairGatewayDialog();
        }.bind(this));
    };

    /**
     *
     */
    SettingsPage.prototype.pairGateway = function () {
        this.console.Ui.turnOff("pairGatewayDialog");

        this.console.consoleService
            .pairGateway(this.meshName/*, account, password*/).done(function () {
            this.console.Ui.turnOff("pairGatewayDialog");
            this.console.safeApply();

            if (this.serverMode == 'local') {
                this.console.consoleService.serverMode = 'tic';
                this.console.consoleService.useLocalNodeBoxIfAvailable = false; // TODO Really?
            }

            this.console.consoleService.applySettings();
            this.console.reinitializeServerCommunication();
        }.bind(this)).fail(function () {
            this.console.consoleService.logError(error);
            this.console.showMessageDialog("Failed to pair Gateway: " + error);
        }.bind(this));
    };

    /**
     *
     */
    SettingsPage.prototype.setPairMeshMode = function (pairMeshMode) {
        this.pairMeshMode = pairMeshMode;
        this.meshName = null;
        this.selectedMesh = null;
    };

    /**
     *
     */
    SettingsPage.prototype.meshNameChanged = function () {
        if (this.meshName && this.meshName.trim().length > 0) {
            this.selectedMesh = {id: this.meshName, label: this.meshName}

        }
    };

    /**
     *
     */
    SettingsPage.prototype.useDefaultCloudServerChanged = function () {
        if (this.useDefaultCloudServer) {
            this.cloudPortalServerUrl = null;
            this.cloudProxyServerUrl = null;
        } else {
            this.cloudPortalServerUrl = "http://localhost:3000";
            this.cloudProxyServerUrl = "http://localhost:3003";
        }
    };

    /**
     *
     */
    SettingsPage.prototype.saveCloudServerUrls = function () {
        this.console.logout();
        this.console.consoleService.saveCloudServerUrls(this.cloudPortalServerUrl, this.cloudProxyServerUrl);
    };
}
